import { IProductRequest, IProduct } from "../@types/product";
import axios from "../utils/axios";

export class ProductService {
  getAllProducts() {
    return axios.get("/product");
  }
  getActiveProducts() {
    return axios.get<IProduct[]>("/product/active");
  }
  getProductDetail(id: string) {
    return axios.get<IProduct>(`/product/${id}`);
  }
  createProduct(payload: IProductRequest) {
    return axios.post<IProduct>("/product", payload);
  }
  updateProduct(id: string, payload: IProductRequest) {
    return axios.patch(`/product/${id}`, payload);
  }
  updateActiveStatus(id: string) {
    return axios.patch(`/product/active/${id}`);
  }
  deleteProduct(id: string) {
    return axios.delete<string>(`/product/${id}`);
  }
  importProducts(file: File) {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post("/product/import", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}
